module.exports = __webpack_public_path__ + "static/media/screen-health-plans.cbe1674d.png";